import * as React from 'react'
import { alpha, styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import CameraEnhanceIcon from '@mui/icons-material/CameraEnhance';
import {

  Receipt,
  ReceiptLong,
  Settings,

  Apartment,

  ViewModule,
  HomeWork,

  LocalAtm,

  ArticleOutlined,
  PersonOutline,
  Speed,
  PaymentsOutlined,
  RequestQuoteOutlined,
  Update,
  UpdateOutlined,
  Insights,
  Image, UploadFile, WifiTethering, RemoveFromQueue,
} from '@mui/icons-material'
import logo from '../../assets/images/blocob3-logo-dark.png'
import logoReceita from '../../assets/images/logo-receita.png'
import logoText from '../../assets/images/blocob3-text-dark.png'
import CssBaseline from '@mui/material/CssBaseline'
import { useLocation } from 'react-router-dom'
import {Badge, Chip, Collapse, useTheme} from '@mui/material'
import {useContext, useEffect, useState} from "react";
import Context from "../../contexts/Context";
import {getCondoType, getRentType, hasFeature} from '../../services/Main/AuthStorage'

const drawerWidth = 250

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}))

const condoPaths = ['/avisos', '/manutencao', '/portaria', '/reserva', '/reclamacoes', '/despesas', '/condominio/imoveis']
const rentPaths = ['/contratos', '/alugueis/imoveis', '/beneficiarios', '/beneficiario', 'repasses']
const businessPaths = ['/contratos', '/alugueis/imoveis', '/beneficiarios', '/beneficiario', 'repasses']


function SubmenuItem({ text, icon, children, keyState, paths, functionMenu }) {
  const { dataProvider, setDataProvider } = useContext(Context)
  const [open, setOpen] = useState(false);
  const location = useLocation()

  function genericFunction() {
    if (paths.some(path => location.pathname.includes(path))) {
      setDataProvider(prevState => ({...prevState, [keyState]: true}));
    } else {
      setDataProvider(prevState => ({...prevState, [keyState]: true}));

    }
  }

  function optionSelected() {
    return paths.some(path => location.pathname.includes(path));
  }

  useEffect(function menuCheck(){
    genericFunction()
  },[location.pathname])


  const handleClick = () => {
    setDataProvider(prevState => ({ ...prevState, [keyState]: !dataProvider?.[keyState]}))
  };
  return (
    <>
      <ListItem disablePadding sx={{mt: '1rem'}}>
        <ListItemButton onClick={handleClick} selected={optionSelected()} >
          <ListItemIcon>
            {icon}
          </ListItemIcon>
          <ListItemText primary={text} />
          {/*{dataProvider?.[keyState] ? <ExpandLess /> : <ExpandMore />}*/}
        </ListItemButton>
      </ListItem>
      <Collapse in={dataProvider?.[keyState]} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </>
  );
}



const Sidebar = (props) => {
  const { user, filters, setFilters } = useContext(Context)
  const {
    perm_transfer,
    perm_dashboard,
    perm_billboard,
    perm_booking,
    perm_complain,
    perm_expense,
    perm_maintenance,
    perm_management,
    perm_bank,
    is_superuser,
  } = user || {}
  const { condoMenu } = filters || {}

  const theme = useTheme()
  const { window } = props
  const location = useLocation()

  const container = window !== undefined ? () => window().document.body : undefined

  const activeRootStyle = {
    // color: 'primary.main',
    fontWeight: 'bold',
    bgcolor: alpha(theme.palette.secondary.light, theme.palette.action.selectedOpacity),
    '&.Mui-selected': {
      backgroundColor: alpha(theme.palette.secondary.light, theme.palette.action.selectedOpacity)
    },
    '&.Mui-selected:hover': {
      backgroundColor: alpha(theme.palette.secondary.light, theme.palette.action.activatedOpacity)
    }
  }

  function renderCondoModule() {
    return (
      perm_billboard ||
      perm_expense ||
      perm_maintenance ||
      perm_management ||
      perm_complain ||
      perm_booking
    );
  }


  const drawerItems = [
    { label: 'Painel', icon: <Speed sx={{ color: 'neutral.main' }} />, path: '/' },
    { label: 'Faturas', icon: <Receipt sx={{ color: 'neutral.main' }} />, path: '/faturas' },
    { label: 'Contratos', icon: <ArticleOutlined sx={{ color: 'neutral.main' }} />, path: '/contratos' },
    { label: 'Repasses', icon: <LocalAtm sx={{ color: 'neutral.main' }} />, path: '/repasses' },
    { label: 'Beneficiários', icon: <PersonOutline sx={{ color: 'neutral.main' }} />, path: '/beneficiarios' },
    { label: 'Clientes', icon: <ViewModule sx={{ color: 'neutral.main' }} />, path: '/clientes' },
    { label: 'Encargos', icon: <RequestQuoteOutlined sx={{ color: 'neutral.main' }} />, path: '/encargos-locaticios' },
    { label: 'Reajustes', icon: <UpdateOutlined sx={{ color: 'neutral.main' }} />, path: '/reajustes' },
    { label: 'Relatório Geral', icon: <Insights sx={{ color: 'neutral.main' }} />, path: '/relatorio-geral/' },
    { label: 'Cobranças', icon: <ReceiptLong sx={{ color: 'neutral.main' }} />, path: '/cobranca' },
    { label: 'Configurações', icon: <Settings sx={{ color: 'neutral.main' }} />, path: '/configuracoes/contas' },
  ]

  const sideBarContent = (
    <div>
      <DrawerHeader>
        <Box component={'div'} sx={{ display: 'flex', alignItem: 'center', pb: 5, pt: 1 }}>
          <img src={logo} alt="" style={{ height: 50 }}/>
          <img src={logoText} alt="" style={{ height: 24, marginLeft: 20, marginTop: 18 }}/>
        </Box>
      </DrawerHeader>
      <List>
        {perm_dashboard && hasFeature('dashboard') &&
            <ListItem key={'dashboard'} disablePadding sx={{my: '1rem'}}>
              <ListItemButton href={'/'} selected={location.pathname === '/'}
                              sx={{ ...(location.pathname === '/' && activeRootStyle) }}>
                <ListItemIcon>
                  <Speed sx={{ color: 'neutral.main' }}/>
                </ListItemIcon>
                <ListItemText primary={'Painel'}/>
              </ListItemButton>
          </ListItem> }

          {hasFeature('invoice') &&
          <ListItem key={'invoice'} disablePadding sx={{my: '1rem'}}>
            <ListItemButton href={'/faturas'} selected={location.pathname.indexOf('/faturas') > -1}
                            sx={{...(location.pathname.indexOf('/faturas') > -1 && activeRootStyle)}}>
              <ListItemIcon>
                <Receipt sx={{color: 'neutral.main'}}/>
              </ListItemIcon>
              <ListItemText primary={'Faturas'}/>
            </ListItemButton>
          </ListItem>
          }

        {(getCondoType() !== 'CONDO') &&
          <>

              {hasFeature('rent_contract') &&
              <ListItem key={'rent'} disablePadding sx={{my: '1rem'}}>
                <ListItemButton href={'/contratos'} selected={location.pathname.indexOf('/contratos') > -1}
                                sx={{...(location.pathname.indexOf('/contratos') > -1 && activeRootStyle)}}>

                    <ListItemIcon >
                      <ArticleOutlined sx={{color: 'neutral.main'}}/>
                    </ListItemIcon>
                    <ListItemText primary={'Contratos'}/>
                </ListItemButton>
              </ListItem>
              }

            {perm_transfer && hasFeature('payout') && <ListItem key={'rent'} disablePadding sx={{my: '1rem'}}>
              <ListItemButton href={'/repasses'} selected={location.pathname.indexOf('/repasses') > -1}
                              sx={{...(location.pathname.indexOf('/repasses') > -1 && activeRootStyle)}}>
                  <ListItemIcon >
                    <LocalAtm sx={{color: 'neutral.main'}}/>
                  </ListItemIcon>
                  <ListItemText primary={'Repasses '}/>
              </ListItemButton>
            </ListItem> }


            {perm_transfer && hasFeature('recipient') &&
              <ListItem key={'rent_recipient'} disablePadding sx={{my: '1rem'}}>
                <ListItemButton href={'/beneficiarios'} selected={location.pathname.indexOf('/beneficiarios') > -1}
                                sx={{...(location.pathname.indexOf('/beneficiarios') > -1 && activeRootStyle)}}>
                    <ListItemIcon >
                      <PersonOutline sx={{color: 'neutral.main'}}/>
                    </ListItemIcon>
                    <ListItemText primary={'Beneficiários'}/>
                </ListItemButton>
              </ListItem>
            }

            { getCondoType() === 'RENT' && hasFeature('client') &&  <ListItem key={'Imóveis'} disablePadding sx={{my: '1rem'}}>
                <ListItemButton href={'/alugueis/imoveis'} selected={location.pathname.indexOf('/alugueis/imoveis') > -1}
                                sx={{...(location.pathname.indexOf('/alugueis/imoveis') > -1 && activeRootStyle)}}>
                    <ListItemIcon>
                      <ViewModule sx={{color: 'neutral.main'}}/>
                    </ListItemIcon>
                    <ListItemText primary={'Imóveis'}/>
                </ListItemButton>
              </ListItem> }

            { getCondoType() === 'BUSINESS' && hasFeature('client') &&  <ListItem key={'Clientes'} disablePadding sx={{my: '1rem'}}>
              <ListItemButton href={'/clientes'} selected={location.pathname.indexOf('/clientes') > -1}
                              sx={{...(location.pathname.indexOf('/clientes') > -1 && activeRootStyle)}}>

                  <ListItemIcon>
                    <ViewModule sx={{color: 'neutral.main'}}/>
                  </ListItemIcon>
                  <ListItemText primary={'Clientes'}/>

              </ListItemButton>
            </ListItem> }
            {(getCondoType() !== 'CONDO') && (
                <ListItem key={'assinatura'} disablePadding sx={{ my: '1rem' }}>
                  <ListItemButton
                      href={'/assinatura'}
                      selected={location.pathname.indexOf('/assinatura') > -1}
                      sx={{
                        ...(location.pathname.indexOf('/assinatura') > -1 && activeRootStyle),
                      }}
                  >
                    <ListItemIcon>
                      <RemoveFromQueue sx={{ color: 'neutral.main' }} />
                    </ListItemIcon>
                    <ListItemText
                        primary={
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            Assinaturas
                            <Chip
                                label="Novo"
                                color="primary"
                                size="small"
                                sx={{ height: 18, fontSize: '0.7rem' }}
                            />
                          </Box>
                        }
                    />
                  </ListItemButton>
                </ListItem>
            )}

            { (getCondoType() === 'BUSINESS' || getCondoType() === 'RENT')  &&<ListItem key={'encargos'} disablePadding sx={{my: '1rem'}}>
              <ListItemButton href={'/encargos-locaticios'} selected={location.pathname.indexOf('/encargos-locaticios') > -1}
                              sx={{...(location.pathname.indexOf('/encargos-locaticios') > -1 && activeRootStyle)}}>
                  <ListItemIcon>
                    <RequestQuoteOutlined sx={{color: 'neutral.main'}}/>
                  </ListItemIcon>
                  <ListItemText primary={'Encargos'}/>
              </ListItemButton>
            </ListItem>}
            { (getCondoType() === 'BUSINESS' || getCondoType() === 'RENT') && hasFeature('reajust') && <ListItem key={'reajustes'} disablePadding sx={{my: '1rem'}}>
              <ListItemButton href={'/reajustes'} selected={location.pathname.indexOf('/reajustes') > -1}
                              sx={{...(location.pathname.indexOf('/reajustes') > -1 && activeRootStyle)}}>

                  <ListItemIcon >
                    <UpdateOutlined sx={{color: 'neutral.main'}}/>
                  </ListItemIcon>
                  <ListItemText primary={'Reajustes'}/>

              </ListItemButton>
            </ListItem>}



            {/*{(user?.is_superuser && getCondoType()) === 'RENT' && <ListItem key={'Vistorias'} disablePadding sx={{my: '1rem'}}>*/}
            {/*  <ListItemButton href={'/vistoria'} selected={location.pathname.indexOf('/vistoria') > -1}*/}
            {/*                  sx={{...(location.pathname.indexOf('/vistoria') > -1 && activeRootStyle)}}>*/}

            {/*      <ListItemIcon>*/}
            {/*        <CameraEnhanceIcon sx={{color: 'neutral.main'}}/>*/}
            {/*      </ListItemIcon>*/}
            {/*      <ListItemText primary={'Vistorias'}/>*/}
            {/*  </ListItemButton>*/}
            {/*</ListItem> }*/}
            { perm_bank === true && hasFeature('report') &&
            <ListItem key={'relatorio-geral'} disablePadding sx={{my: '1rem'}}>
              <ListItemButton href={'/relatorio-geral/'} selected={location.pathname.indexOf('relatorio-geral/') > -1}
                              sx={{...(location.pathname.indexOf('/relatorio-geral/') > -1 && activeRootStyle)}}>

                  <ListItemIcon >
                    <Insights sx={{color: 'neutral.main'}}/>
                  </ListItemIcon>
                  <ListItemText primary={'Relatório Geral'}/>

              </ListItemButton>
            </ListItem>
            }
            {getRentType() === 'REAL_ESTATE' && hasFeature('dimob') &&
            <ListItem key={'dimob'} disablePadding sx={{my: '1rem'}}>
              <ListItemButton href={'/dimob'} selected={location.pathname.indexOf('/dimob') > -1}
                              sx={{...(location.pathname.indexOf('/dimob') > -1 && activeRootStyle)}}>

                  <ListItemIcon >
                    <img src={logoReceita} alt="Dimob" style={{width: '30px'}}/>
                  </ListItemIcon>
                  <ListItemText sx={{ml: 0.5}} primary={'Dimob'}/>
              </ListItemButton>
            </ListItem>
            }

          </>
        }
        {/*Seção de Condomínio*/}
        {getCondoType() === "CONDO" &&
          <SubmenuItem
            text={'Condomínio'}
            icon={<Apartment sx={{color: 'neutral.main'}}/>}
            keyState={'condoMenu'}
            paths={condoPaths}
          >

              <ListItem key={'expense'} disablePadding sx={{my: '1rem'}}>
                <ListItemButton href={'/despesas'} selected={location.pathname.indexOf('/despesas') > -1}
                                sx={{...(location.pathname.indexOf('/despesas') > -1 && activeRootStyle)}}>
                  <Box sx={{display: 'flex', mx: 2}}>
                    <ListItemIcon>
                      <ReceiptLong sx={{color: 'neutral.main'}}/>
                    </ListItemIcon>
                    <ListItemText primary={'Despesas'}/>
                  </Box>
                </ListItemButton>
              </ListItem>



              <ListItem key={'units'} disablePadding sx={{my: '1rem'}}>
                <ListItemButton href={'/condominio/imoveis'} selected={location.pathname.indexOf('/condominio/imoveis') > -1}
                                sx={{...(location.pathname.indexOf('/condominio/imoveis') > -1 && activeRootStyle)}}>
                  <Box sx={{display: 'flex', mx: 2}}>
                    <ListItemIcon>
                      <ViewModule sx={{color: 'neutral.main'}}/>
                    </ListItemIcon>
                    <ListItemText primary={'Imóveis'}/>
                  </Box>
                </ListItemButton>
              </ListItem>

          </SubmenuItem>
        }

        { perm_bank === true && hasFeature('charge') &&
        <ListItem key={'charge'} disablePadding sx={{my: '1rem'}}>
          <ListItemButton href={'/cobranca'} selected={location.pathname.indexOf('/cobranca') > -1}
                          sx={{...(location.pathname.indexOf('/cobranca') > -1 && activeRootStyle)}}>
            <ListItemIcon>
              <ReceiptLong sx={{color: 'neutral.main'}}/>
            </ListItemIcon>

            <ListItemText primary={'Cobranças'}/> &nbsp;&nbsp;


          </ListItemButton>
        </ListItem>
        }
          <ListItem key={'settings'} disablePadding sx={{my: '1rem'}}>
            <ListItemButton href={'/configuracoes/contas'}
                            selected={location.pathname.indexOf('/configuracoes/contas') > -1}
                            sx={{...(location.pathname.indexOf('/configuracoes/contas') > -1 && activeRootStyle)}}>
              <ListItemIcon>
                <Settings sx={{color: 'neutral.main'}}/>
              </ListItemIcon>
              <ListItemText primary={'Configurações'}/>
            </ListItemButton>
          </ListItem>

      </List>
    </div>
  )

  return (
    <>
    {user &&
        <Box sx={{ display: 'flex' }} >
          <CssBaseline/>
          <Box component="nav" sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }} aria-label="Bloco B3">
            <Drawer
              container={container}
              variant="temporary"
              open={props.mobileMenu}
              onClose={props.handleDrawerToggle}
              ModalProps={{
                keepMounted: true,
              }}
              sx={{
                display: { xs: 'block', md: 'none' },
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
              }}
              PaperProps={{
                sx: {
                  backgroundColor: 'secondary.main',
                  color: 'neutral.main'
                }
              }}>
              {sideBarContent}
            </Drawer>
            <Drawer
              variant="permanent"
              open
              sx={{
                display: { xs: 'none', md: 'block' },
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
              }}
              PaperProps={{
                sx: {
                  backgroundColor: 'secondary.main',
                  color: 'neutral.main'
                }
              }}>
              {sideBarContent}
            </Drawer>
          </Box>
        </Box>
      }
    </>
  )
}

export default Sidebar
